import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
